<template>
  <div class="case-creation__card mb-15">
    <div class="case-creation__heading">
      <div class="title-with-icon">
        <span class="icon">
          <img src="@/assets/images/icons/icon-test-info.svg" alt="icon" class="img-fluid" />
        </span>
        <h3 class="title">TEST TUBES INFORMATION</h3>
      </div>
    </div>
    <div class="case-creation__body" :loading="loading">
      <div class="billing-information-tabs">
        <div class="tube-scroll-wrapper">
          <div v-if="tubeInfo.length">
            <div class="tube-header">
              <div class="tube-column">Test Tube</div>
              <div class="tube-column">Status</div>
              <div class="tube-column">Test Information</div>
            </div>

            <div class="tube-cards-block">
              <div class="tube-card" v-for="(tube, index) in tubeInfo" :key="index">
                <div class="tube-column img-block">
                  <div class="test-tube-img-block">
                    <img :src="getDownloadUrl(tube.image_url)" alt="Test Tube" width="100%" height="100%" />
                  </div>
                  <p class="tube-name">{{ tube?.tube_name }}</p>
                </div>

                <template v-if="tube.tests && tube.tests.length">
                  <div class="tube-column">
                    <el-select
                      v-model="dropdownStatus[index]"
                      placeholder="Select Status"
                      size="small"
                    >
                      <el-option label="Collected" value="Collected" />
                      <el-option label="Not Collected" value="Not Collected" />
                      <el-option
                        v-if="getTotalDropdownOptions(tube) > 1"
                        label="Partially Collected"
                        value="Partially Collected"
                      />
                    </el-select>
                  </div>
                  <div class="tube-column">
                    <el-select
                      v-model="selectCategory[index]"
                      placeholder="Select Category"
                      multiple
                      size="small"
                      collapse-tags
                      style="width: 200px!important;"
                      @change="handleSelectionChange(index)"
                      @blur="validateSelection(index)"
                    >
                      <el-option
                        v-for="testGroup in tube.tests"
                        :key="testGroup.title"
                        :label="isTestDisabled(testGroup) ? `${testGroup.title} (In-house at another lab)` : testGroup.title"
                        :value="testGroup.title"
                        :disabled="isTestDisabled(testGroup)"
                      />
                    </el-select>

                    <p v-if="selectErrors[index]" class="error-text">{{ selectErrors[index] }}</p>
                    <p v-if="getInhouseOtherLabTests(tube).length" class="inhouse-note">
                      {{ getInhouseOtherLabTests(tube).join(', ') }} — In-house at another lab
                    </p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NewCaseTestTubeInfo',
  data() {
    return {
      dropdownStatus: [],
      selectCategory: [],
      hasUserInteracted: [],
      selectErrors: [],
      suppressWatcher: false,
      isLoaded: false,
      loading: false, // Added loading property
    };
  },
  props: {
    caseType: {
      type: [Array, String, null],
      default: null
    }
  },
  computed: {
    // ...mapGetters('labSquireOrderTestTubes', ['getLabSquireOrderTestTubesInfo']),
    tubeInfo() {
      return []; //this.getLabSquireOrderTestTubesInfo?.data || [];
    },
    selectedTubeInformation() {
      return this.tubeInfo.map((tube, index) => ({
        tube_id: tube._id,
        tube_name: tube.tube_name,
        image_url: tube.image_url,
        status: this.dropdownStatus[index],
        selected_tests: this.selectCategory[index],
      }));
    }
  },
  mounted() {
    this.initTubeInfoWatcher();
    this.initSelectCategoryWatcher();
    this.initDropdownStatusWatcher();
    this.initCaseTypeWatcher();
  },
  methods: {
    initTubeInfoWatcher() {
      this.$watch(
        () => this.tubeInfo,
        (newData) => {
          this.handleTubeInfoChange(newData);
        },
        { immediate: true }
      );
    },

    initSelectCategoryWatcher() {
      this.$watch(
        () => this.selectCategory,
        (newSelections) => {
          this.handleSelectCategoryChange(newSelections);
        },
        { deep: true }
      );
    },

    handleSelectCategoryChange(newSelections) {
      if (this.suppressWatcher) return;

      newSelections.forEach((selectedTests, index) => {
        if (!this.hasUserInteracted[index]) return;

        const tube = this.tubeInfo[index];
        const totalOptions = this.getTotalDropdownOptions(tube);
        const allSelected = selectedTests.length === totalOptions;

        this.suppressWatcher = true;

        if (selectedTests.length === 0) {
          this.dropdownStatus[index] = 'Not Collected';
          this.selectErrors[index] = 'Test tubes not collected';
        } else {
          this.selectErrors[index] = '';
          this.dropdownStatus[index] = allSelected
            ? 'Collected'
            : totalOptions > 1
            ? 'Partially Collected'
            : 'Collected';
        }

        this.suppressWatcher = false;
      });

      this.emitTubeData();
    },

    initDropdownStatusWatcher() {
      this.$watch(
        () => this.dropdownStatus,
        (newStatuses) => {
          this.handleDropdownStatusChange(newStatuses);
        },
        { deep: true }
      );
    },

   handleDropdownStatusChange(newStatuses) {
      if (this.suppressWatcher) return;

      newStatuses.forEach((status, index) => {
        const tube = this.tubeInfo[index];

        this.suppressWatcher = true;

        if (status === "Collected") {
          const selectedTests = [];
          tube.tests.forEach(testGroup => {
              if (!this.isTestDisabled(testGroup)) {
                selectedTests.push(testGroup.title);
              }
          });
          this.selectCategory[index] = selectedTests;
          this.selectErrors[index] = '';
        } else if (status === "Not Collected") {
          this.selectCategory[index] = [];
          this.selectErrors[index] = 'Test tubes not collected';
        } else if (status === "Partially Collected") {
          // No action needed, just ensure the status is set correctly
        }

        this.suppressWatcher = false;
      });

      this.emitTubeData();
    },


    initCaseTypeWatcher() {
      this.$watch(
        () => this.caseType,
        (newVal) => {
          this.handleCaseTypeChange(newVal);
        },
        { immediate: true }
      );
    },


    handleCaseTypeChange(newVal) {
      const newCaseTypes = Array.isArray(newVal) ? newVal : (newVal ? [newVal] : []);
      const oldCaseTypes = this.prevCaseTypes || [];

      const removedCaseTypes = oldCaseTypes.filter(type => !newCaseTypes.includes(type));
    
      this.prevCaseTypes = [...newCaseTypes];

      if (newCaseTypes.length === 0) {
        this.cleanupState();
      } else {
        if (removedCaseTypes.length > 0) {
          this.removeCaseTypes(removedCaseTypes);
        }
      }
    },

    async handleTubeInfoChange(newData) {
      this.loading = true; // Start loading
      this.isLoaded = false;
      if (Array.isArray(newData)) {
        this.dropdownStatus = [];
        this.selectCategory = [];
        this.hasUserInteracted = [];
        this.selectErrors = [];

        for (const [index, tube] of newData.entries()) {
          const path = tube?.image_url?.split('.com/')[1];
          if (path) {
            await this.$store.dispatch('testTubesImageGeneration/fetchDownloadUrl', path);
          }
          this.selectCategory.push([]);
          this.dropdownStatus.push('Collected');
          this.hasUserInteracted.push(false);
          this.selectErrors.push('');
        }

        this.isLoaded = true;
        this.emitTubeData();
      } else {
        // Defensive: clear state if no data
        this.dropdownStatus = [];
        this.selectCategory = [];
        this.hasUserInteracted = [];
        this.selectErrors = [];
        this.emitTubeData();
      }
      this.loading = false; // End loading
    },


    getDownloadUrl(imageUrl) {
      if (!imageUrl) return "";

      try {
        const decodedUrl = decodeURIComponent(imageUrl);
        const path = decodedUrl.split(".com/")[1];
        const storeUrl = this.$store.getters["testTubesImageGeneration/getDownloadUrlByPath"](path);
        return storeUrl || decodedUrl;
      } catch (e) {
        console.error("Failed to decode URL:", e);
        return imageUrl;
      }
    },

    getTotalDropdownOptions(tube) {
      let count = 0;
      tube.tests.forEach(testGroup => {
        if (this.isTestDisabled(testGroup)) {
          return;
        }
        if (testGroup.title === "All Tests") {
          count += (testGroup.test_ids || []).length;
        } else {
          count += 1;
        }
      });
      return count;
    },

    // A test is non-selectable when its lab-order code is restricted for the
    // current lab (colony labs DLW-TX / DLW-HOU block the full list, the
    // parent DLW lab blocks only DLW_UIBC). Uses the global helper set.
    isTestDisabled(testGroup) {
      const code = testGroup?.lab_order_code;
      return Boolean(code) && this.disabledLabOrderCodes.has(code);
    },
    getInhouseOtherLabTests(tube) {
      const restrictedCodes = this.disabledLabOrderCodes;
      if (!restrictedCodes.size) return [];
      return (tube?.tests || [])
        .filter((t) => t?.lab_order_code && restrictedCodes.has(t.lab_order_code))
        .map((t) => t.title);
    },

    handleSelectionChange(index) {
      this.hasUserInteracted[index] = true;
      this.validateSelection(index);
      this.emitTubeData();
    },

    validateSelection(index) {
      if (this.selectCategory[index].length === 0) {
        this.selectErrors[index] = 'Test tubes not collected';
      } else {
        this.selectErrors[index] = '';
      }
      this.emitTubeData();
    },

    emitTubeData() {
      this.$emit('tube-data-information', this.selectedTubeInformation);
    },
    removeCaseTypes(caseTypesToRemove) {
      const remaining = this.tubeInfo.filter(tube => !caseTypesToRemove.includes(tube.case_type));
      // this.$store.commit('labSquireOrderTestTubes/RESET_LAB_SQUIRE_INFO', remaining);
    },

    async refetchTubeInfo() {
      try {
        this.cleanupState();
      } catch (error) {
        console.error("Failed to refetch tube info:", error);
      }
    },

    cleanupState() {
      this.dropdownStatus = [];
      this.selectCategory = [];
      this.hasUserInteracted = [];
      this.selectErrors = [];
      this.isLoaded = false;
      // this.$store.commit('labSquireOrderTestTubes/RESET_LAB_SQUIRE_INFO');
    }
  },
  beforeUnmount() {
    this.cleanupState();
  }
};

</script>


<style scoped lang="scss">
.case-creation__card {
  margin-top: 1px;
  overflow-x: auto;
}
.case-creation__body {
  padding: 0;
}
.case-creation__heading .title {
  font-weight: bold;
}
.tube-scroll-wrapper {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  width: 100%;
}
.tube-header {
  display: flex;
  padding: 5px 20px;
  border-bottom: 1px solid #E7E7F7;
}
.tube-column {
  flex: 1;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding: 5px;

  .test-tube-img-block {
    width: 40px;
    height: 40px;
    padding: 0.5rem;
    border: 1px solid #E7E7F7;
    border-radius: 6px;
  }
  .tube-name {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
  }
  &.img-block {
    column-gap: 1rem;
  }
}
.tube-cards-block {
  max-height: 235px;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
    border: 2px solid transparent;
    background-clip: content-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
  }
  .tube-card {
    display: flex;
    padding: 5px 0px;
    margin: 0 20px;
    border-bottom: 1px solid #E7E7F7;

    &:nth-last-child(1) {
      border-bottom: none;
    }
  }
}
.el-select {
  width: 160px !important;
  font-size: 12px;
}
::v-deep(.el-select .el-input__inner) {
  background-color: #F9F9F9;
  color: #000;
  font-weight: 500;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid #f9f9f9;
}
::v-deep(.el-select .el-input__suffix .el-input__icon) {
  color: #000000;
}
::v-deep(.el-select .el-input__inner::placeholder) {
  color: #000 !important;
  font-weight: 500 !important;
}
::v-deep(.el-select__tags-text) {
  color: #000 !important;
  font-weight: 500 !important;
}
.error-text {
  color:  #f24a55;
  font-size: 11px;
  margin-top: 4px;
  text-align: left;
}
.inhouse-note {
  color: #b06a00;
  font-size: 11px;
  font-style: italic;
  margin-top: 4px;
  text-align: left;
}
</style>
